import axios from "axios";

export const addToCart = ({
  width,
  height,
  productId,
  canvasData,
  count,
  cartId,
  proboProductOptions,
}) =>
  new Promise((resolve, reject) => {
    axios
      .post("/wp-json/dpe/v1/cart", {
        width,
        height,
        productId,
        canvasData,
        count,
        cartId,
        proboProductOptions,
      })
      .then((resp) => {
        resolve(resp.data);
      })
      .catch((err) => {
        reject(err);
      });
  });
